module.exports = __webpack_public_path__ + "static/media/error.1b10e668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.svg
// module id = 213
// module chunks = 0